import { Helmet } from "react-helmet";
import PlatformLayout from "../section/platform/platform-layout";

const PlatformPage = () => {
    <Helmet>
        <title>Our Platforms | Innovative Travel & Tourism Solutions by Digital Tourism</title>
        <meta name="description" content="Explore Digital Tourism’s platforms including Sri Lanka Driver Guide and WanderTropics. Discover smart travel tools, booking solutions, and digital ecosystems built for modern travelers." />
        <meta name="keywords" content="tourism platforms Sri Lanka, Sri Lanka Driver Guide, WanderTropics, travel booking platforms, digital tourism solutions" />
    </Helmet>

    return (
        <>
            <PlatformLayout />
        </>
    );
}

export default PlatformPage;